import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide"
import "@splidejs/react-splide/css"
import Image from "components/elements/image"
import PropTypes from "prop-types"
import React from "react"
// Borrows the homepage location carousel's styling, including its segmented
// progress-bar pagination.
import "components/sections/locationSectionV2/carousel.scss"

const ClinicCarousel = ({ slides }) => (
  <div className="location-section-v2--carousel">
    <Splide
      aria-label="Centre photos"
      hasTrack={false}
      options={{
        type: "fade",
        arrows: false,
        autoplay: true,
        pauseOnHover: true,
        rewind: true,
        interval: 5000,
        gap: "16px",
        pagination: true,
        perMove: 1,
        perPage: 1,
        speed: 300,
        easing: "ease-in-out",
      }}
    >
      <div className="custom-wrapper">
        <SplideTrack>
          {slides.map(slide => (
            <SplideSlide key={slide.id}>
              <Image
                alt={slide.title || ""}
                className="location-section-v2--carousel-image"
                image={slide.fluid}
              />
            </SplideSlide>
          ))}
        </SplideTrack>
      </div>
    </Splide>
  </div>
)

ClinicCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      fluid: PropTypes.object,
      id: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

export default ClinicCarousel
